import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    custom: string;
    favorites: string;
    managePresets: string;
    preset: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for custom preset option (user presets) */
            custom: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PresetSelectRow.custom?c=1seqz1nd5vlia", defaultMessage: "Custom" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for favorite export presets */
            favorites: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PresetSelectRow.favorites?c=4rithei6otwd", defaultMessage: "Favorites" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to open Premiere Pro preset manager modal */
            managePresets: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PresetSelectRow.managePresets?c=36mji6m9tgzqd", defaultMessage: "Manage Presets" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the preset selection dropdown */
            preset: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PresetSelectRow.preset?c=28qxpus22pdtg", defaultMessage: "Preset" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
